import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../common/state';
import { EMetroTravelType } from '../../../../json_query';
import { changeUndergroundTravelWithSearch } from '../../../state/underground_travel';
import { isFiltersRedesignExperimentEnabled } from '../../../../selectors/isFiltersRedesignExperimentEnabled';
import { IDispatchProps, IOwnProps, IStateProps, UndergroundTravel } from './index';

export const UndergroundTravelContainer = connect<IStateProps, IDispatchProps, IOwnProps>(
  (state: IAppState) => {
    const jsonQuery = (state.filters.backup && state.filters.backup.jsonQuery) || state.filters.jsonQuery;

    return {
      travelType: jsonQuery.only_foot && jsonQuery.only_foot.value,
      travelTime: jsonQuery.foot_min && jsonQuery.foot_min.value.lte,
      withNewTag: isFiltersRedesignExperimentEnabled(state),
    };
  },
  (dispatch: Dispatch) => ({
    onUndergroundTravelChanged: (travelType: EMetroTravelType, travelTime: number | undefined, withSearch: boolean) => {
      dispatch(changeUndergroundTravelWithSearch(travelType, travelTime, withSearch));
    },
  }),
)(UndergroundTravel);
